package org.zest.insan_360_website.data.page_states

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch
import org.zest.insan_360_website.components.widgets.ToastState
import org.zest.insan_360_website.components.widgets.ToastType
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.model.MaintenanceStatusPayload
import org.zest.insan_360_website.model.MaintenanceToggleRequest
import org.zest.insan_360_website.model.SuperAdminRequest
import org.zest.insan_360_website.model.UserRole
import org.zest.insan_360_website.utils.NetworkUtils
import org.zest.insan_360_website.utils.processResponse

object MaintenanceState {
    var isMaintenanceMode by mutableStateOf(false)
    var isLoading by mutableStateOf(false)

    fun reset() {
        isMaintenanceMode = false
        isLoading = false
    }

    fun fetchMaintenanceStatus(scope: CoroutineScope) {
        val email = AuthState.email ?: return
        val role = AuthState.role
        if (role != UserRole.SUPER_ADMIN) return

        scope.launch {
            isLoading = true
            try {
                val request = SuperAdminRequest<Unit>(email = email, role = role)
                val response = NetworkUtils.postSecureApi("/api/super-admin/system/maintenance-status", request)
                    ?: return@launch
                val payload = processResponse<MaintenanceStatusPayload>(
                    response = response,
                    fallbackErrorLog = LanguageSettings.Maintenance.error_toggling.localized
                )
                if (payload != null) isMaintenanceMode = payload.isMaintenanceMode
            } catch (e: Exception) {
                console.error("${LanguageSettings.Maintenance.error_toggling.localized}${e.message}") // LANGUAGE: set
            } finally {
                isLoading = false
            }
        }
    }

    fun toggleMaintenance(scope: CoroutineScope, toast: ToastState, enable: Boolean, onCompleted: () -> Unit = {}) {
        val email = AuthState.email ?: return
        val role = AuthState.role
        if (role != UserRole.SUPER_ADMIN) return

        scope.launch {
            isLoading = true
            try {
                val request = SuperAdminRequest(
                    email = email,
                    role = role,
                    request = MaintenanceToggleRequest(enable = enable)
                )
                val response = NetworkUtils.postSecureApi("/api/super-admin/system/maintenance-toggle", request)
                    ?: return@launch
                // Retrieve the payload from the return value; onSuccess lambda is () -> Unit
                val payload = processResponse<MaintenanceStatusPayload>(
                    response = response,
                    toast = toast,
                    fallbackErrorLog = LanguageSettings.Maintenance.error_toggling.localized
                )
                if (payload != null) {
                    isMaintenanceMode = payload.isMaintenanceMode
                    val msg = if (payload.isMaintenanceMode) LanguageSettings.Maintenance.mode_now_on.localized else LanguageSettings.Maintenance.mode_now_off.localized
                    toast.show(msg, if (payload.isMaintenanceMode) ToastType.ERROR else ToastType.SUCCESS)
                }
            } catch (e: Exception) {
                if (e is kotlinx.coroutines.CancellationException) throw e
                toast.show("${LanguageSettings.Maintenance.error_toggling.localized}${e.message}", ToastType.ERROR)
            } finally {
                isLoading = false
                onCompleted()
            }
        }
    }
}